<!--
 * @Author: Axs <i@axs.email>
 * @Date: 2022-07-18 14:23:16
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-07-21 17:33:06
 * @Description: 
 * @FilePath: /src/page/movie/components/thumbnail.vue
-->
<template>
    <div class="component component-thumbnail">
        <div
            class="radian"
            :style="{ marginLeft: ((middleColumn-1) / seatList[0].length) * 100 + '%' }"
        ></div>
        <div
            class="seat-line"
            v-for="(seatLineItem, seatListIndex) in seatList"
            :key="seatListIndex"
        >
            <div
                class="seat-item"
                v-for="(seatItem, seatIndex) in seatLineItem"
                :key="seatIndex"
                :class="[
                    { 'show-border': seatItem && seatItem.middle },
                    { 'love-1': seatItem && seatItem.love == 1 },
                    { 'love-2': seatItem && seatItem.love == 2 },
                ]"
            >
                <template v-if="seatItem && seatItem.love != 2">
                    <img
                        class="seat-image"
                        :src="
                            require('@/assets/icons/' +
                                (seatItem.status == 'LK'
                                    ? 'select'
                                    : seatItem.select
                                    ? 'my-select'
                                    : 'default-' +
                                      (seatItem.areaPriceIndex > 2 ? 2 : seatItem.areaPriceIndex)) +
                                (seatItem.love == 1
                                    ? '-love-left'
                                    : seatItem.love == 2
                                    ? '-love-right'
                                    : '-default') +
                                '-mini.png')
                        "
                        alt=""
                    />
                    {{ seatItem.status }}
                </template>
                <template v-if="!seatItem">
                    <div class="thumbnail-none-bg"></div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    props: {
        seatList: {
            type: Array,
            default: [],
        },
        middleColumn: {
            type: Number,
            default: -1,
        },
    },
    created() {},
};
</script>

<style lang="less" scoped>
@import url('~@/lib/base.less');
.component-thumbnail {
    display: inline-block;
    padding: .pxToRem(15) [] .pxToRem(20) [] .pxToRem(12) [];
    background: rgba(0, 0, 0, 0.8);
    font-size: 0;
    .radian {
        width: .pxToRem(90) [];
        height: .pxToRem(5) [];
        background: url('~@/assets/icons/icon-selection-hall-bg.png');
        background-size: cover;
        background-repeat: no-repeat;
        margin-bottom: .pxToRem(12) [];
        transform: translateX(-50%);
    }
    .seat-line {
        display: flex;
        height: .pxToRem(9) [];
    }
    .seat-item {
        width: .pxToRem(8) [];
        height: .pxToRem(8) [];
        margin-right: .pxToRem(1) [];
        margin-bottom: .pxToRem(1) [];
        &.love-1 {
            width: .pxToRem(17) [];
            height: .pxToRem(8) [];
            .seat-image {
                width: .pxToRem(17) [];
                height: .pxToRem(8) [];
            }
        }
        &.love-2 {
            width: .pxToRem(0) [];
            .seat-image {
                width: .pxToRem(0) [];
            }
        }
    }
    .seat-image {
        width: .pxToRem(8) [];
        height: .pxToRem(8) [];
    }
}
</style>
